
<template>
  <ComponentLayout
    id="compare-table"
    fluid_main_container
    main_color="var(--color-main-green)">
    <template #breadcrumbs>
      <TenderBreadcrumbs
        :additional_breads="additional_breads"
        :current="$t('Tenders.ComparativeTable')"/>
    </template>
    <template #main_content>
      <template v-if="loading">
        <v-skeleton-loader
          :boilerplate="false"
          class="mt-10 pr-8"
          :tile="false"
          type="heading"
          width="40%"/>
        <v-skeleton-loader
          :boilerplate="false"
          class="mt-3 pr-8"
          :tile="false"
          type="sentences"
          width="40%"/>
        <v-skeleton-loader
          :boilerplate="false"
          class="mt-10 pr-8"
          height="200px"
          :tile="false"
          type="table-row"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="false"
          class="mt-2 pr-8"
          height="200px"
          :tile="false"
          type="table-row"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="false"
          class="mt-2 pr-8"
          height="200px"
          :tile="false"
          type="table-row"
          width="100%"/>
      </template>
      <template v-else>
        <div class="pa-0 h1-headline text-left">
          {{ $t('Tenders.ComparativeTable') }}
        </div>
        <div
          v-if="tenderSubTitle.row1 || tenderSubTitle.row2"
          class="px-0 pt-8 pb-2 text-start h6-text black--text">
          {{ tenderSubTitle.row1 }}
          <div
            v-if="tenderSubTitle.row2"
            class="h8-text mt-2 light_black--text">
            {{ tenderSubTitle.row2 }}
          </div>
        </div>

        <template v-if="!!tender && tender.tenderId">
          <ComparativeTableAI
            v-if="growthBook.ai_functionals && $can('use', 'aiRequirementsFromDocument')"
            :bids="bids"
            :can-edit="can_edit"
            :lot-groups-view="isLotGroupsView"
            :tender="tender"
            @changeWinners="reloadTender"/>
          <ComparativeTableLotGroups
            v-else-if="isLotGroupsView"
            :bids="bids"
            :can-edit="can_edit"
            :tender="tender"
            @changeWinners="reloadTender"/>
          <ComparativeTableDefault
            v-else
            :bids="bids"
            :can-edit="can_edit"
            :tender="tender"/>
        </template>

        <sAlert
          v-else
          class="mt-5"
          show-icon
          type="warning">
          {{ $t('Errors.STHWrong') }}
        </sAlert>
      </template>
    </template>
    <template #footer>
      <ComponentsTemplatesFooter
        key="footer">
        <sButton
          data-qa="go-to-tenderitem"
          :to="{name: 'tenderitem', params: { id: tender.tenderId, org: $route.params.org }}"
          type="text">
          <sIcon
            class="s-btn-icon"
            rotate="90"
            size="10"
            type="long-arrow"/>
          {{ $t('Tenders.BackToTender') }}
        </sButton>
      </ComponentsTemplatesFooter>
    </template>
  </ComponentLayout>
</template>
<script>
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import ComponentsTemplatesFooter from 'pages/templates/ComponentsTemplatesFooter.vue'

import ComparativeTableDefault from 'pages/tender item/ComparativeTableDefault.vue'
import ComparativeTableAI from 'pages/tender item/ComparativeTableAI.vue'
import ComparativeTableLotGroups from 'pages/tender item/ComparativeTableLotGroups.vue'

import { tenderMixin, snackbarMixin, modalMixin } from 'mixins'
import { mapGetters } from 'vuex'
import { COMPARE_VIEW_LOT_GROUPS, lotGroupItemKey } from 'helpers/lotGroupPositions'

export default {
  name: 'comparativeTable',
  mixins: [tenderMixin, snackbarMixin, modalMixin ],
  data() {
    return {
      item: null,
      tender: {},
      loading: false,
      currencies: [],
      by_participant: false,
      in_history: false,
      can_edit: false,
    }
  },
  async created() {
    this.by_participant = this.$route.name == 'participantHistoryComparativeTable'
    this.in_history = this.$route.path.includes('bids-history')
    await this.$store.dispatch('setCurrencies')
      .then((result) => {
        this.currencies = result
      }),
    await this.getItem()
    // тендер не завантажився (getTenderItem уже переадресував на 404) — агременти не запитуємо
    if (this.tender?.tenderId) {
      await this.getAgreements()
    }
  },
  computed: {
    ...mapGetters({
      compareItems: 'getCompareItems',
    }),
    /**
     * Пропозиції, обрані на сторінці тендеру. Беремо лише якщо вони з цього ж тендеру —
     * інакше (прямий перехід / історія браузера) показуємо всі пропозиції тендеру
     */
    elements() {
      const { tenderId, items } = this.compareItems || {}
      return tenderId != null && String(tenderId) === String(this.$route.params.tenderId) ? items : []
    },
    /** порівняння в режимі лот-позицій (групування «(позиції)» на вкладці «Пропозиції») */
    isLotGroupsView() {
      return this.$route.query?.view === COMPARE_VIEW_LOT_GROUPS && !!this.$_isGroupEnabled
    },
    tenderSubTitle() {
      return {
        row1: this.item ? this.item.title :
          this.by_participant ? this.by_participant.organizationName :
            this.tender && this.tender.tenderId ? '#' + this.tender.tenderNumber + ' ' + this.tender.title : '',
        row2: this.tender && this.tender.category ? this.tender.category.code + ' ' + this.tender.category.title : ''
      } 
    },
    additional_breads() {
      let result ,
        lot_history = this.$route.name == 'lotHistoryComparativeTable',
        item = {}
      if ( this.item ) {
        item = {
          text: this.item?.title ||  '–',
          to: {name: 'offersForLot',
            params: { tenderId: this.$route.params.tenderId, lotId: this.$route.params.lotId, org: this.$route.params.org}}
        }
      } else if ( this.by_participant ) {
        item = {
          text: this.by_participant?.organizationName || '–'
        }
      }


      if ( lot_history || this.by_participant ) {
        result = [
          {
            text: this.$t('Tenders.History'),
            action: () => this.$router.push(  {name: 'bidsHistory', params: { tenderId: this.tender.tenderId, org: this.$route.params.org}} )
          },
        ]
        if ( lot_history ) {
          result.push({
            text: this.$t('Tenders.Lots'),
            current: true
          })
          item.action = () => this.$router.push({name: 'bidsHistoryByLots',
            params: { tenderId: this.$route.params.tenderId, lotId: this.$route.params.lotId, org: this.$route.params.org}})
        } else {
          result.push({
            text: this.$t('Tenders.Suppliers'),
            current: true
          })
          item.action = () => this.$router.push({name: 'bidsHistoryByParticipants',
            params: { tenderId: this.$route.params.tenderId, participantId: this.$route.params.participantId, org: this.$route.params.org}})
        }
        result.push( {...item, current: true })
      } else if (item && Object.keys(item).length) {
        result = [ item ]
      }
      return result
    },
    lots() {
      return this.item ? [this.item] : this.tender.lots
    },
    bids() {
      if (this.isLotGroupsView) {
        return this.lotGroupBids
      }
      if (this.elements && this.elements.length) {
        return this.elements
      }
      let bids = this.getBids(this.$_.cloneDeep(this.tender?.bids)?.sort((a, b) => {
        let func = (a) => a.bidDetails.reduce((total, bid ) => {
          return total += bid.currencyPrice || 0
        }, 0)
        return func(a) - func(b)
      }), this.tender)
      bids = bids.filter(bid => this.lots.find(lot => lot.lotId == bid.lotId))
      return bids
    },
    /**
     * Агреговані рядки «постачальник × лот»: обрані на вкладці «Пропозиції» або,
     * якщо їх немає (F5 / прямий перехід), усі активні пропозиції тендеру, згруповані по лотах
     */
    lotGroupBids() {
      if (!this.tender?.bids?.length) {
        return []
      }
      const bids = this.getBids(this.$_.cloneDeep(this.tender.bids), this.tender)
        .filter(bid => ['ACTIVE', 'DRAFT'].includes(bid.bidStatus))
      const items = this.$_getGroupsPositionsByLot(bids, { value: 'lotGroupNumber', positionValue: 'participant' })
        .flatMap(group => group.items)
      return this.compareKeys.size ? items.filter(item => this.compareKeys.has(lotGroupItemKey(item))) : items
    },
    /**
     * Ключі «учасник × лот», обрані на вкладці «Пропозиції». Самі рядки будуються з тендеру —
     * так після перечитування (reloadTender) ознаки переможця/кращої ціни завжди актуальні
     */
    compareKeys() {
      const items = (this.elements || []).filter(item => Array.isArray(item.positions))
      return new Set(items.map(lotGroupItemKey))
    },
  },
  methods: {
    /** перечитати тендер без скелетона (після вибору/зняття переможця) */
    async reloadTender() {
      const tender = await this.$store.dispatch('getTenderItem', { id: this.$route.params.tenderId, condition: true })
      if (tender) {
        this.tender = tender
      }
    },
    async getAgreements() {
      await this.$store.dispatch('agreeLatest', [Number(this.tender.tenderId)]).then(res => {
        this.$_setAgreementValues(res || [])
        if (!res?.length ) {
          this.$emit('changeAcceptors', null)
        }
        return res
      })
        .finally(() => {
          this.loadAgreements = false
        })
    },
    async getItem() {
      this.loading = true
      await this.$store.dispatch('getTenderItem', {
        id: this.$route.params.tenderId
      })
        .then(async res => {
          this.tender = res
          if ( this.in_history) {
            this.tender.bids = await this.$store.dispatch('getTenderBidHistory',
              { tenderId: +res.tenderId,
                model: this.by_participant ? { bidderId: +this.$route.params.participantId} : { lotId: +this.$route.params.lotId} })
          }
          if ( this.by_participant ) {
            this.by_participant = this.tender.bids[0].bidderInfo
          }
          this.item = this.tender?.lots.find(lot => {
            return lot.lotId == +this.$route.params.lotId
          })
        })
        .catch(res => this.$log_error(res))
        .finally(() => {
          this.loading = false
          this.can_edit = this.$_checkCanEdit(this.tender, this.$_agreements)
        })
    },
  },
  beforeDestroy() {
    this.$store.commit('setCompareItems')
  },
  components: {
    ComponentLayout,
    TenderBreadcrumbs,
    ComparativeTableAI,
    ComparativeTableDefault,
    ComparativeTableLotGroups,
    ComponentsTemplatesFooter,
  }
}
</script>
<style lang="scss" scoped>
.footer{
  position: fixed;
  bottom: 0;
  z-index: 100;
  width: 100vw;
  height: 72px;
  border-top: 2px solid var(--v-secondary__green_chosen-base) !important;
  background-color: var(--v-main__green-base) !important;
  box-shadow: none;
  .btn {
    font-weight: 600;
    letter-spacing: 0.03em;
  }
}
.lot-title td {
  padding: 15px 0 !important;
}

.list-item {
  min-height: 32px !important;
}

.cell {
  max-width: 230px;
  min-width: 230px;
  padding: 0 !important;
}

.modal-column {
  width: 200px;
  max-width: 200px;
  min-width: 200px;
}

.td-value {
  max-width: 300px;
  height: 100%;
}
</style>
<style lang="scss">
#component-layout-compare-table {
  .v-skeleton-loader .v-skeleton-loader__table-row * {
    height: 200px;
  }

  .v-skeleton-loader__table-cell.v-skeleton-loader__bone {
    width: 200px;
    margin-right: 15px;
  }

  .compare-card {
    position: relative;
    .v-data-table__wrapper {
      max-height: calc(100vh - 100px);
      // padding-bottom: 16px;
      overflow-y: auto !important;
    }

    table {
      border-radius: 12px;
      // height: 800px;
      // border-collapse: separate;
      padding-right: 55px;
      position: relative;

      tr {
        min-height: 20px !important;
        position: relative;

        td:first-child,
        th:first-child,
        &.lot-title span {
          position: sticky;
          left: -1px;
          z-index: 10;
        }

        th,
        td {
          height: unset;
          border: none !important;
          border-right: thin solid var(--v-main__green-base) !important;
          border-bottom: thin solid var(--v-main__green-base) !important;

          &:first-child {
            border-left: thin solid var(--v-main__green-base) !important;
          }
        }

        th:last-child {
          border-radius: 0 12px 0 0;
        }

        th {
          position: sticky;
          top: 0px;
          z-index: 20 !important;
          padding: 16px 24px !important;
          border-bottom: thin solid var(--v-main__green-base) !important;
          white-space: normal !important;

          .v-input--checkbox .v-icon {
            color: rgba(var(--black-color-rgba), 0.2);
            font-size: 20px;
          }
          &:first-child {
            z-index: 40 !important;
          }
        }

        &:last-child td:last-child {
          border-radius: 0 0 12px 0;
        }

        &.lot-title:not(:first-child) td {
          border-top: thin solid var(--v-main__green-base) !important;
          border-bottom: thin solid var(--v-main__green-base) !important;
        }

        &.lot-title:first-child td {
          // border-top: thin solid var(--v-main__green-base) !important;
          border-bottom: thin solid var(--v-main__green-base) !important;
        }

        &.info-row {
          td {
            border: none !important;
            border-right: thin solid var(--v-main__green-base) !important;
            border-bottom: thin solid var(--v-main__green-base) !important;
            padding: 5px 24px !important;
            vertical-align: top;

            &:first-child {
              border-left: thin solid var(--v-main__green-base) !important;
            }
          }

          &:last-child {

            td:last-child {
              border-bottom-right-radius: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
